import { FileUp, LoaderCircle } from 'lucide-react';
import { FC, useState } from 'react';

import { clsx } from 'clsx';

import { ID_INSTRUCTION_ATTRIBUTE, ID_PASSPORT_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { HStack, VStack } from '@shared/ui/Stack';

import { downloadSelectedFiles } from '../../../api/getProductData';
import { DownloadFilesReq } from '../../../model/types/donwloadFilesReq';
import { Caption } from '../Caption/Caption';
import { EmptyState } from '../EmptyState/EmptyState';
import cls from './Passport.module.scss';

type PassportProps = {
  isInstruction?: boolean;
};

const ICON_SIZE = 32;

const getObjectFromArray = (array: string[], value: boolean) => {
  return array.reduce((acc, item) => ({ ...acc, [item]: value }), {});
};

export const Passport: FC<PassportProps> = ({ isInstruction }) => {
  const [loading, setLoading] = useState<Record<string, boolean>>({});

  const productId = useAppSelector((state) => state.product.data.id);
  const values = useAppSelector(
    (state) => state.product.data.props[isInstruction ? ID_INSTRUCTION_ATTRIBUTE : ID_PASSPORT_ATTRIBUTE]?.values
  );

  const docIds = values?.map(({ value }) => value);

  const downloadAll = async () => {
    setLoading((prevState) => ({ ...prevState, ...getObjectFromArray(docIds, true) }));

    const body: DownloadFilesReq = {
      productId: productId,
      propId: isInstruction ? ID_INSTRUCTION_ATTRIBUTE : ID_PASSPORT_ATTRIBUTE
    };

    const res = await downloadSelectedFiles(body);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(res);
    link.download = `${isInstruction ? 'инструкции' : 'паспорта'}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setLoading((prevState) => ({ ...prevState, ...getObjectFromArray(docIds, false) }));
  };

  const downloadFile = async (docs: string[]) => {
    setLoading((prevState) => ({ ...prevState, ...getObjectFromArray(docs, true) }));
    const body: DownloadFilesReq = {
      productId: productId,
      propId: isInstruction ? ID_INSTRUCTION_ATTRIBUTE : ID_PASSPORT_ATTRIBUTE,
      folderId: docs.map((item) => item).toString()
    };
    const res = await downloadSelectedFiles(body);
    const link = document.createElement('a');
    const name = docs[0].split('/')[1];
    link.href = window.URL.createObjectURL(res);
    link.download = `${name}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setLoading((prevState) => ({ ...prevState, ...getObjectFromArray(docs, false) }));
  };

  if (!values?.length) {
    return <EmptyState />;
  }

  return (
    <div>
      <Caption>
        <HStack className={clsx(cls.titleWrapper)}>
          <div>{isInstruction ? 'Инструкции' : 'Паспорт'}</div>

          {values.length > 1 && (
            <div
              className={cls.downloadAll}
              onClick={() => downloadAll()}
            >
              Скачать все
            </div>
          )}
        </HStack>
      </Caption>

      <div className={cls.itemWrapper}>
        {docIds.map((value) => (
          <div
            className={clsx(cls.item, { [cls.loading]: loading[value] })}
            key={value}
            onClick={loading[value] ? undefined : () => downloadFile([value])}
          >
            <VStack className={cls.itemContent}>
              {loading[value] ? (
                <LoaderCircle
                  className={cls.loader}
                  size={ICON_SIZE}
                  color={'#FE9867'}
                />
              ) : (
                <FileUp size={ICON_SIZE} />
              )}
              <div className={cls.itemTitle}>{value.split('/')[1]}</div>
            </VStack>
          </div>
        ))}
      </div>
    </div>
  );
};
